import React from 'react'
import GenericCancelController from './GenericCancelController'
import { useFetchList } from 'store'
import { Requisition } from 'models'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

const CancelRequisitionController = (props) => {
	const { data, dismiss, id } = props
	const { i18n } = useGlobal()

	const {
		contents: [requisition],
	} = useFetchList(
		[
			`clinical_processes/${data.processId}/requisitions/${data.processRequest?.requisitionId}`,
		],
		[Requisition.fromJSON]
	)

	const infoItems = [
		{
			title: i18n`Service provider`,
			text: requisition?.establishment?.name || '-',
			icon: 'location-alt',
		},
		{
			title: i18n`Scheduled date`,
			text: requisition?.scheduledDate?.shortDateFormat || '-',
			icon: 'calendar',
		},
		{
			title: i18n`Requiring provider`,
			text: requisition?.requiringEstablishment?.name || '-',
			icon: 'location-alt',
		},
		{
			title: i18n`State`,
			text: data.processRequest?.requestStateDescription || '-',
			icon: 'user',
		},
		{
			title: i18n`Requiring specialty`,
			text: requisition?.appointment?.medicalSpecialty?.name || '-',
			icon: 'leading',
		},
		{
			title: i18n`Transport`,
			text: requisition?.transport || '-',
			icon: 'transport',
		},
		{
			title: i18n`Prescribing doctor`,
			text: requisition?.prescribingDoctor || '-',
			icon: 'medical-info',
		},
		{
			title: i18n`Clinical information`,
			text: requisition?.clinicalInformation || '-',
			icon: 'clinical-notes',
		},
	]

	const reason = {
		title: i18n`Nullify reason`,
		text: data.processRequest?.reason,
	}

	return (
		<GenericCancelController
			data={{ task: data, infoItems, reason }}
			requisition={requisition}
			dismiss={dismiss}
			id={id}
			isRequisition={true}
		/>
	)
}

export default CancelRequisitionController
